/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'

import { server } from '../engine/server'
import { modal } from '../../core/utilities/modal'

var CollaboratorManager = Class.create({
  	initialize: function() {
  		this.server = server;
    },
    getCards: function(callback) {
		var url = "collaborator/cards";
		var data = this.server.getData(url, null, true, "GET");
		data
		.done(function(response){
            if(callback) {
                callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Failed to find any cards!", "danger", "top", "center");
		});
    },
	getCard: function(id, callback) {
		var url = "collaborator/card/" + id;
		var data = this.server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Couldn't find this card!", "danger", "top", "center");
		});
    },
    addCard: function(id, params, callback) {
		var url = "collaborator/card/" + id;
		var data = this.server.getData(url, params, true, "POST");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Couldn't add card!", "danger", "top", "center");
		});
    },
    updateCard: function(id, params, callback) {
		var url = "collaborator/card/" + id;
		var data = this.server.getData(url, params, true, "PUT");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Couldn't add card!", "danger", "top", "center");
		});
    },
    cardsMoved: function(params, callback) {
		var url = "collaborator/cards/moved";
		var data = this.server.getData(url, {cards:params}, true, "PUT");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Couldn't move cards!", "danger", "top", "center");
		});
    },
    deleteCard: function(id, callback) {
		var url = "collaborator/card/" + id;
		var data = this.server.getData(url, null, true, "DELETE");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Couldn't delete card!", "danger", "top", "center");
		});
    },
    createMoveOutChecklist: function(params, callback) {
		var url = "collaborator/template/moveout";
		var data = this.server.getData(url, params, true, "POST");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Couldn't create checklist!", "danger", "top", "center");
		});
    }
});

export let collaboratorManager = new CollaboratorManager();


// WEBPACK FOOTER //
// app/core/controllers/CollaboratorManager.js